
export default {
  name: 'NativeStatusBar'
}
